module.exports = __webpack_public_path__ + "files/3c782f874a50f646b0a42c1644356a45.png";